import { render, staticRenderFns } from "./FlashSaleStepProductList.vue?vue&type=template&id=fadf4be6&scoped=true&"
import script from "./FlashSaleStepProductList.vue?vue&type=script&lang=js&"
export * from "./FlashSaleStepProductList.vue?vue&type=script&lang=js&"
import style0 from "./FlashSaleStepProductList.vue?vue&type=style&index=0&id=fadf4be6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadf4be6",
  null
  
)

export default component.exports